"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
const _ = require("lodash");
class User {
    constructor(data) {
        this.data = data;
    }
    getUserName() {
        return this.data.userName;
    }
    hasClaim(claim) {
        return _.includes(this.data.claims, claim);
    }
    hasAnyClaim(claims) {
        return _.filter(this.data.claims, claim => _.includes(claims, claim)).length > 0;
    }
    getDisplayName() {
        return this.data.userName;
    }
    isLoggedIn() {
        return this.data.userName != null;
    }
}
exports.User = User;
